import { Component, OnDestroy, VERSION } from "@angular/core";
import { OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Subscription } from "rxjs";
import { AuthMsgService } from "../../../auth/auth-msg.service";
//import { FreshdeskWidgetService } from "../../../services/freshdesk-widget.setvice"
import { AuthService } from "../../../auth/auth.service";
import { ClaimCategory } from "../../../core/enums/auth/ClaimCategory";
import { ClaimSubCategory } from "../../../core/enums/auth/ClaimSubCategory";
import { ClaimValue } from "../../../core/enums/auth/ClaimValue";
import { UserProfile } from "../../../models/userprofile";
import { OrgSettingsService } from "src/org-settings/org-settings.service";
import { OrganisationDTO } from "src/DTOs/Organisations/Models/OrganisationDTO";
import { HubSpotWidgetService } from "../../../services/hubspot-widget.service";

@Component({
  selector: "nav-menu",
  templateUrl: "./navmenu.component.html",
  styleUrls: ["./navmenu.component.css"],
})
export class NavMenuComponent implements OnInit, OnDestroy {
  public userProfile: UserProfile;
  public IsAuth: boolean;
  private _isPassiveMode: boolean;
  public orgId:string ='';
  subscription: Subscription;
  hideSubscription: Subscription;
  version: string;

  showNavbar: boolean = true;
  referralsEnabled: boolean = false;

  constructor(
    private authMsgService: AuthMsgService,
    private auth: AuthService,
    private orgSettings: OrgSettingsService,
    private hubSpotWidgetService : HubSpotWidgetService
  ) {
    this.version = environment.version; // VERSION.full;
    // subscribe to home component messages
    this.subscription = this.authMsgService
      .getMessage()
      .subscribe((message) => {
        this.IsAuth = message as boolean;
        {
          if (environment.debug_mode) {
            console.log("this.authMsgService.getMessage()=" + message);
          }
        }
      });
    this.hideSubscription = this.authMsgService.sideNavHidden().subscribe(show => {
      this.showNavbar = show;
    });

    this.hubSpotWidgetService.createWidget();
  }

  ngOnInit(): void {
    if (this.auth.currentUser.idTokenClaims["organization_id"]) {
      this.orgSettings.getOrganisation(this.auth.currentUser.idTokenClaims["organization_id"] as string).subscribe((org: OrganisationDTO) => {
        this.referralsEnabled = org.FeatureToggles.referrals_Enabled;
      });

  
    }

    var win = window as any;
    // for now visible only by admin
    this.auth.getClaims$().subscribe((claims:UserProfile)=>{
      this.userProfile = claims;
    });

    //--------------------------------------------
    // get passive status - begin
    //--------------------------------------------
    this.getPassiveModeStatus();
    //--------------------------------------------
    // get  passive status - ends
    //--------------------------------------------
  }

  displayAnalyticsMenu(): boolean {
    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("PerformanceReports"),
        ClaimSubCategory.Name("All")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("PerformanceReports"),
        ClaimSubCategory.Name("Linked")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportPatientResponses"),
        ClaimSubCategory.Name("All")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportPatientResponses"),
        ClaimSubCategory.Name("Linked")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportPatientFeedbacks"),
        ClaimSubCategory.Name("All")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportPatientFeedbacks"),
        ClaimSubCategory.Name("Linked")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportAlerts"),
        ClaimSubCategory.Name("All")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportAlerts"),
        ClaimSubCategory.Name("Linked")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportNotes"),
        ClaimSubCategory.Name("All")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportNotes"),
        ClaimSubCategory.Name("Linked")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportDeliverySms"),
        ClaimSubCategory.Name("All")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportDeliverySms"),
        ClaimSubCategory.Name("Linked")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportDeliveryEmail"),
        ClaimSubCategory.Name("All")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("DataExportDeliveryEmail"),
        ClaimSubCategory.Name("Linked")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("PatientCommunications"),
        ClaimSubCategory.Name("None")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("AftercareDashboardView"),
        ClaimSubCategory.Name("Organization")
      ) ||
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("AftercareDashboardView"),
        ClaimSubCategory.Name("Linked")
      ) ||
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("AftercareDashboardView"),
        ClaimSubCategory.Name("Member")
      )
    ) {
      return true;
    }

    return false;
  }

  displayOrgSettignsMenu(): boolean {
    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("OrganizationManagement"),
        ClaimSubCategory.Name("None")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("MemberManagement"),
        ClaimSubCategory.Name("All")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("MemberManagement"),
        ClaimSubCategory.Name("Self")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("CenterManagement"),
        ClaimSubCategory.Name("None")
      )
    ) {
      return true;
    }

    return false;
  }

getPassiveModeStatus():void{
  this.userProfile = this.auth.getClaims();
  this.orgId = this.userProfile.organization_id
  if(this.orgId===undefined){
    this.orgId=this.auth.currentUser.idTokenClaims["extension_organizationid"] as string
  }
  this.orgSettings.checkPassiveMode(this.orgId).subscribe(
    (isPassive: boolean) => {
      this._isPassiveMode = isPassive;
      if (environment.debug_mode) {
      console.log('Is passive mode enabled:', isPassive);}
    },
    (error: any) => {
      if (environment.debug_mode) {
      console.error('Error occurred while checking passive mode:', error);}
    }
  );
}

  displayContentMenu(): boolean {
    if(this._isPassiveMode )
    {
      return false;
    }

   if(
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("ProcedureProtocolManagement"),
        ClaimSubCategory.Name("None")
      ) || this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("ProcedureProtocolManagement"),
        ClaimSubCategory.Name("Subscription")
      )
    ) {
      return true;
    }
    return false;
  }

  displayReferral(): boolean {
    if (!this.referralsEnabled) return false;
    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("ReferralManagement"),
        ClaimSubCategory.Name("None")
      )
    ) {
      return true;
    }

    return false;
  }

  displayLeads(): boolean {
    return this.auth.isOrgManager() || this.auth.isAdmin()
  }
  
  displayPatientMenu(): boolean {
    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("PatientManagement"),
        ClaimSubCategory.Name("All")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("PatientManagement"),
        ClaimSubCategory.Name("Linked")
      )
    ) {
      return true;
    }

    return false;
  }

  displayProcedureMenu(): boolean {
    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("PatientProcedureManagement"),
        ClaimSubCategory.Name("All")
      )
    ) {
      return true;
    }

    if (
      this.auth.hasPermissionCenter(
        "",
        ClaimValue.Name("Read"),
        ClaimCategory.Name("PatientProcedureManagement"),
        ClaimSubCategory.Name("Linked")
      )
    ) {
      return true;
    }

    return false;
  }

  displayAlertsMenu(): boolean {
    return !this.auth.IsAnalyticsViewer()
  }

  ngOnDestroy(): void {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
    this.hideSubscription.unsubscribe();
  }

  

  openHelpWidget(event: Event){
    event.stopPropagation();
    this.hubSpotWidgetService.toggleWidget();
  }

  openPatientLeadsPage(): void {
    const url = environment.appConfig.patient_leads_url + '/#/activity/patient-leads/';
    window.open(url, "_blank");
  }

  openSettingsPage(): void {
    const url = environment.appConfig.patient_leads_url + '/#/organisation/org-settings';
    window.open(url, "_blank");
  }
}
